export default __webpack_public_path__ + "static/media/installer_qr_code.e5ef6445.png";